/* 333 Libaas — Theme JS */
(function () {
  'use strict';

  /* ---------- Mobile menu drawer ---------- */
  function initDrawer() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!toggle || !drawer) return;
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    var overlay = drawer.querySelector('.mobile-drawer__overlay');

    function open() { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('open'); document.body.style.overflow = ''; }

    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in-view'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (mainImg && src) mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      var minus = stepper.querySelector('[data-qty-minus]');
      var plus = stepper.querySelector('[data-qty-plus]');
      if (!input) return;
      function val() { return parseInt(input.value, 10) || 1; }
      if (minus) minus.addEventListener('click', function () {
        if (val() > 1) { input.value = val() - 1; input.dispatchEvent(new Event('change')); }
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = val() + 1; input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ---------- Variant selector → image + price sync ---------- */
  function initVariant() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var select = form.querySelector('[data-variant-select]');
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add-btn]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (!select) return;

    select.addEventListener('change', function () {
      var v = variants.filter(function (x) { return String(x.id) === String(select.value); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_formatted;
      if (stickyPrice) stickyPrice.innerHTML = v.price_formatted;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-add-text') : 'Sold Out';
      }
      if (v.featured_image) {
        var mainImg = document.querySelector('[data-gallery-main] img');
        if (mainImg) mainImg.src = v.featured_image;
      }
    });
  }

  /* ---------- Announcement copy for mobile single-line ---------- */

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initReveal();
    initGallery();
    initQty();
    initVariant();
  });
})();
